// src/components/common/LoadingSpinner.js
import React from 'react';
import { Loader } from 'lucide-react';

const LoadingSpinner = ({
    size = 'medium',
    message = 'Loading...',
    className = '',
    showOverlay = false,
    color = 'blue'
}) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        medium: 'w-8 h-8',
        large: 'w-12 h-12',
        xl: 'w-16 h-16'
    };

    const textSizes = {
        small: 'text-sm',
        medium: 'text-base',
        large: 'text-lg',
        xl: 'text-xl'
    };

    const colorClasses = {
        blue: 'text-blue-600 dark:text-blue-400',
        green: 'text-green-600 dark:text-green-400',
        red: 'text-red-600 dark:text-red-400',
        yellow: 'text-yellow-600 dark:text-yellow-400',
        purple: 'text-purple-600 dark:text-purple-400',
        gray: 'text-gray-600 dark:text-gray-400'
    };

    const spinner = (
        <div className={`flex flex-col items-center justify-center ${className}`}>
            <Loader
                className={`${sizeClasses[size]} animate-spin ${colorClasses[color]} mb-2`}
            />
            {message && (
                <p className={`${textSizes[size]} text-gray-600 dark:text-gray-400`}>
                    {message}
                </p>
            )}
        </div>
    );

    if (showOverlay) {
        return (
            <div className="fixed inset-0 bg-white dark:bg-gray-900 bg-opacity-75 dark:bg-opacity-75 flex items-center justify-center z-50">
                {spinner}
            </div>
        );
    }

    return spinner;
};

// Skeleton component for content placeholders
export const SkeletonCard = ({ className = '' }) => (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow p-6 animate-pulse ${className}`}>
        <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded mb-4"></div>
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded mb-2"></div>
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
    </div>
);

export const SkeletonTable = ({ rows = 5, className = '' }) => (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden ${className}`}>
        <div className="animate-pulse">
            <div className="h-12 bg-gray-300 dark:bg-gray-600 mb-2"></div>
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="h-10 bg-gray-200 dark:bg-gray-700 mb-1 mx-4"></div>
            ))}
        </div>
    </div>
);

// Loading states for different contexts
export const AttendanceLoading = () => (
    <div className="flex justify-center items-center py-12">
        <LoadingSpinner size="large" message="Loading attendance data..." />
    </div>
);

export const TeamLoading = () => (
    <div className="flex justify-center items-center py-12">
        <LoadingSpinner size="large" message="Loading team data..." />
    </div>
);

export const ExportLoading = () => (
    <div className="flex justify-center items-center py-8">
        <LoadingSpinner size="medium" message="Exporting data..." />
    </div>
);

export default LoadingSpinner;